import { Box, Grid2 as Grid, Typography } from "@mui/material";

const ContractorSlip = ({ foundContractor }) => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      {foundContractor && (
        <Box
          sx={{
            border: "1px solid #ccc",
            boxShadow: "2px 6px 12px rgba(0, 0, 0, 0.5) !important",
            borderRadius: 2,
            backgroundColor: ["Suspended", "Inactive"].includes(
              foundContractor.status
            )
              ? "rgba(229, 57, 53, 0.2)"
              : "rgba(0, 200, 83, 0.2)",

            p: 2,
            zIndex: 99999,
          }}
        >
          <Grid container spacing={1}>
            {[
              ["DBA Name", foundContractor?.dba_name || "-"],
              ["Primary Name", foundContractor?.primary_name || "-"],
              ["License Type", foundContractor?.license_type || "-"],
              ["Expires", foundContractor?.expires || "-"],
              ["Address", foundContractor?.address || "-"],
            ].map(([label, value]) => (
              <Grid size={{ xs: 12 }} key={label}>
                <Box sx={{ display: "flex" }}>
                  <Typography sx={{ fontWeight: "bold", minWidth: 130 }}>
                    {label}:
                  </Typography>
                  <Typography sx={{ ml: 1 }}>{value}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ContractorSlip;
